var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 86,
  fill: "none",
  viewBox: "0 0 67 86"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 5,
  d: "M3 86V3h64"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 34.429,
  x2: 34.429,
  y1: 1.602,
  y2: 86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgTopLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjciIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA2NyA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgODZMMy4wMDAwMyAzTDY3IDMiIHN0cm9rZT0idXJsKCNwYWludDBfbGluZWFyXzQ2M18xMzI2KSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl80NjNfMTMyNiIgeDE9IjM0LjQyOTQiIHkxPSIxLjYwMjI5IiB4Mj0iMzQuNDI5NCIgeTI9Ijg2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMyNkYwMjgiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDExRjIxIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";